module.exports = __webpack_public_path__ + "img/zdyx2.b4a3a7e4.png";